import { FC } from "react";
import { motion } from "framer-motion";
import styles from "./Rating.module.scss";
import classNames from "classnames";
import { ApplicationBadge, BadgeType } from "@entities/communities";
import star from "@assets/lottie/topUsers.json";
import js from "@assets/lottie/js.json";
import go from "@assets/lottie/go.json";
import { Player } from "@lottiefiles/react-lottie-player";

interface IRatingProps {
  isReactions?: boolean;
  badges: ApplicationBadge[];
  userId?: string;
}

export const Rating: FC<IRatingProps> = (props) => {
  const { isReactions, badges, userId } = props;

  const badgeRenderMap: Partial<
    Record<
      BadgeType,
      { kind: "lottie"; src: unknown } | { kind: "img"; src: string }
    >
  > = {
    [BadgeType.Founding]: { kind: "lottie", src: star },
  };

  const specialUserLottie =
    userId === "87def195-9d15-42a0-b93a-ba57e2a5e639"
      ? js
      : userId === "09e3cebb-721d-43c6-af17-569fba652400"
      ? go
      : undefined;
  return (
    <motion.div
      className={classNames(
        styles.ratingContainer,
        isReactions && styles.isReactions
      )}
    >
      <div className={styles.ratingImageContainer}>
        <div className={styles.ratingImage}>
          {badges.map((badge) => {
            const cfg = badgeRenderMap[badge.title];
            const srcToUse = (specialUserLottie ??
              (cfg?.src as object)) as object;
            return (
              <Player
                key={badge.id}
                autoplay={isReactions ? false : true}
                loop
                src={srcToUse}
                className={styles.badgeImage}
              />
            );
          })}
        </div>
      </div>
    </motion.div>
  );
};
